import React, { useEffect } from "react";
import styled from "styled-components";

interface ModalProps {
	maxWidth?: string;
	width?: string;
	padding?: string;
	centerContent?: boolean;
	overflowY?: string;
	children?: React.ReactNode;
	onClose?: () => void;
}

interface ModelWrapperStyles
	extends Pick<ModalProps, "maxWidth" | "width" | "padding" | "overflowY"> {
	center?: boolean;
}

const Modal: React.FC<ModalProps> = ({
	maxWidth,
	width,
	children,
	padding,
	centerContent,
	onClose,
	overflowY,
}) => {
	useEffect(() => {
		// Lock body scroll while the modal is open so the page behind can't be
		// nudged (e.g. by a two-finger swipe on a trackpad).
		const previousBodyOverflow = document.body.style.overflow;
		document.body.style.overflow = "hidden";

		function handleKeyDown(e: KeyboardEvent) {
			if (e.key === "Escape" && onClose) {
				onClose();
			}
		}

		document.addEventListener("keydown", handleKeyDown, false);

		return () => {
			document.body.style.overflow = previousBodyOverflow;
			document.removeEventListener("keydown", handleKeyDown, false);
		};
	}, [onClose]);

	return (
		<ModalContainer>
			<ModalWrapper
				maxWidth={maxWidth}
				width={width}
				padding={padding}
				center={centerContent}
				overflowY={overflowY}
			>
				{children}
			</ModalWrapper>
		</ModalContainer>
	);
};

export default Modal;

const ModalContainer = styled.div`
	position: fixed;
	z-index: 1000;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	background: rgba(0, 0, 0, 0.6);
	overflow-y: auto;
	overscroll-behavior: contain;
`;

const ModalWrapper = styled.section<ModelWrapperStyles>`
	background: white;
	width: ${(props) => (props.width ? props.width : "100%")};
	max-width: ${(props) => (props.maxWidth ? props.maxWidth : "32.5rem")};
	margin: 10vh auto 5em auto;
	height: auto;
	${(props) => (props.center || props.center === undefined ? "align-items: center;" : "")}
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	padding: ${(props) => (props.padding ? props.padding : "2.5rem")};
	max-height: 90vh;
	overflow-y: ${(props) => (props.overflowY ? props.overflowY : "auto")}; ;
`;
